import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { translation_EN } from "./locales/en/translation";
import { translation_ptBR } from "./locales/pt-BR/translation";
import { translation_ES } from "./locales/es/translation";

const SUPPORTED_LANGUAGES = ["en", "pt-BR", "es"];

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    load: "currentOnly",
    resources: {
      en: {
        translation: translation_EN,
      },
      "pt-BR": {
        translation: translation_ptBR,
      },
      es: {
        translation: translation_ES,
      },
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      convertDetectedLanguage: (lng) => {
        if (lng.startsWith("pt")) return "pt-BR";
        if (lng.startsWith("es")) return "es";
        if (lng.startsWith("en")) return "en";
        // Return as-is for unsupported languages so i18next skips them
        // via supportedLngs and tries the next language in navigator.languages.
        // fallbackLng: "en" handles the case where no language matches.
        return lng;
      },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
